import React from "react";
import Image from "next/image";

interface LogoProps {
  width?: number;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({ width = 1024, height = 1024 }) => {
    return (
        <Image
            className={`w-${width} h-${height}`}
            src="https://vlady.dev/assets/img/vlady_logo.png"
            alt="Logo"
            width={width}
            height={height}
        />
    );
};

export default Logo;
